import {safeAccess} from '../../utils/objectUtils';

export class HTMLVideoElementProxy {
  constructor(private readonly rawPlayer: HTMLVideoElement) {}

  get currentTime() {
    return safeAccess(() => this.rawPlayer.currentTime);
  }

  get duration() {
    return safeAccess(() => this.rawPlayer.duration);
  }

  get muted() {
    return safeAccess(() => this.rawPlayer.muted);
  }

  get height() {
    return safeAccess(() => this.rawPlayer.height);
  }

  get width() {
    return safeAccess(() => this.rawPlayer.width);
  }

  get autoplay() {
    return safeAccess(() => this.rawPlayer.autoplay);
  }

  get src() {
    return safeAccess(() => this.rawPlayer.src);
  }

  get currentSrc() {
    return safeAccess(() => this.rawPlayer.currentSrc);
  }

  get readyState() {
    return safeAccess(() => this.rawPlayer.readyState);
  }

  get volume() {
    return safeAccess(() => this.rawPlayer.volume);
  }

  get error() {
    return safeAccess(() => this.rawPlayer.error);
  }

  get textTracks() {
    return safeAccess(() => this.rawPlayer.textTracks);
  }

  get paused() {
    return safeAccess(() => this.rawPlayer.paused);
  }

  get ended() {
    return safeAccess(() => this.rawPlayer.ended);
  }

  get playbackRate() {
    return safeAccess(() => this.rawPlayer.playbackRate);
  }

  get videoWidth() {
    return safeAccess(() => this.rawPlayer.videoWidth);
  }

  get videoHeight() {
    return safeAccess(() => this.rawPlayer.videoHeight);
  }

  getVideoPlaybackQuality() {
    // this API is not supported in all browsers (especially on iOS Safari it was added quite late)
    // reference: https://developer.mozilla.org/en-US/docs/Web/API/VideoPlaybackQuality
    return safeAccess(() => this.rawPlayer.getVideoPlaybackQuality?.());
  }

  addEventListener = (...args: Parameters<HTMLVideoElement['addEventListener']>) => {
    safeAccess(() => this.rawPlayer.addEventListener(...args));
  };

  removeEventListener = (...args: Parameters<HTMLVideoElement['removeEventListener']>) => {
    safeAccess(() => this.rawPlayer.removeEventListener(...args));
  };

  /**
   * Returns the underlying raw HTMLVideoElement.
   * Used only for overwriting original load function. Should not be used otherwise.
   */
  getRawPlayer(): HTMLVideoElement {
    return this.rawPlayer;
  }
}
